import { StateIntegerFilter } from '../../store/slices/filters/types'
import { useFindLocaleText } from '../../text-localisation'

enum InputTypes {
  number = 'number',
  text = 'text',
}

export enum IntegerFieldTypes {
  age = 'age',
}

export type IntegerFilterInputConfig = {
  name: string
  value: number | null
  minValue: number
  maxValue: number
  type: InputTypes
  placeholder: string
  label: string
  errorMessage: string
}

export const useIntegerInputFilter = (
  integerFilter?: StateIntegerFilter,
): {
  createConfiguration: (
    integerFieldType: IntegerFieldTypes,
    value: number | null,
  ) => IntegerFilterInputConfig
  isIntegerFilterValueValid: (value: number | null) => boolean
} => {
  const localiseText = useFindLocaleText()

  const configurations = {
    age: {
      name: 'age',
      type: InputTypes.number,
      placeholder: `${localiseText('find.age_input.label')}...`,
      label: localiseText('find.age_input.label'),
      minValue: integerFilter?.min || 0,
      maxValue: integerFilter?.max || 0,
      errorMessage: localiseText('find.age_input.error_message', {
        min: integerFilter?.min.toString() || '0',
        max: integerFilter?.max.toString() || '0',
      }),
    },
  }

  const createConfiguration = (
    integerFieldType: IntegerFieldTypes,
    value: number | null,
  ): IntegerFilterInputConfig => {
    return { ...configurations[integerFieldType], value }
  }

  const isIntegerFilterValueValid = (value: number | null) => {
    return (
      value === null ||
      (Number(value) >= Number(integerFilter?.min) &&
        Number(value) <= Number(integerFilter?.max))
    )
  }

  return { createConfiguration, isIntegerFilterValueValid }
}
